export const GLOBAL_HTTP_ERRORS = new Map<number, string>([
  [504, "GATEWAY_TIMEOUT"],
  [503, "SERVICE_NOT_AVAILABLE"],
  [502, "BAD_GATEWAY"],
  [500, "INTERNAL_SERVER_ERROR"],
  [413, "PAYLOAD_TOO_LARGE"],
  [408, "REQUEST_TIMEOUT"],
  [405, "REQUEST_METHOD_NOT_ALLOWED"],
  [404, "REQUEST_URL_NOT_FOUND"],
]);

export const UNAUTHENTICATED_RESPONSE_MESSAGES = {
  access_expired: "Given token not valid for any token type",
  refresh_expired: "Invalid access and refresh tokens",
  refresh_blocked: "Invalid or blacklisted access or refresh tokens",
} as const;
